import { render } from "./CamenBert.vue?vue&type=template&id=4ba68036&scoped=true"
import script from "./CamenBert.vue?vue&type=script&lang=js"
export * from "./CamenBert.vue?vue&type=script&lang=js"

import "./CamenBert.vue?vue&type=style&index=0&id=4ba68036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba68036"]])

export default __exports__